module.exports = __webpack_public_path__ + "img/MonedaGraf.c9434401.png";